export default {
  common: {
    labels: {
      onlyInstalled: "Ach Suiteáilte",
      showMore: "Taispeáin Níos Mó",
      showLess: "Taispeáin Níos Lú",
      reportDate: "Dáta an Tuairisc",
      reportTime: "Am an Tuairisc",
      reportAtGlance: "Tuairisc go gairid",
      fleetStatus: "Stádas na Flot",
      fleetSize: "Méid na Flot",
      totalDevices: "Uirlisí Iomlán",
      addNewAlert: "Cuir Fógra Nua Leis",
      addNewRecepient: "Cuir Saoránach Nua Leis",
      selectEVModel: "Roghnaigh Patrún EV",
      selectHPModel: "Roghnaigh Patrún HP",
      reRunAnalysis: "Ath-Rithint anailíse",
      devicesWith: "Uirlisí le",
      logout: "Logáil Amach",
      name: "Ainm",
      email: "Ríomhphost",
      nickname: "Leasainm",
      openAsPage: "Oscail mar Leathanach",
      editDeviceDetails: "Cuir Faisnéis Uirlis in Eagar",
      manageAlerts: "Bainistigh Rabhálacha",
      noLocation: "Níor aimsíodh aon áit do na hiompar seo",
      selectDeviceToCompare: "Roghnaigh uirlis le haghaidh comparáide",
      includeAmbientTemperature: "Cuir Teocht Timpeallachta San áireamh",
      startDate: "Dáta tosaithe",
      endDate: "Dáta críochnaithe",
      thisFieldIsRequired: "Tá an réimse seo riachtanach",
      mustBeLessThan50Characters: "Ní mór go mbeadh níos lú ná 50 carachtar ann",
      numberHasToBeBetween0And100: "Ní mór don uimhir a bheith idir 0 agus 100",
      timeOfDay: "Am an Lae",
      indicatesRequiredField: "Taispeánann Réimse Riachtanach",
      editDetails: "Eagar Sonraí",
      noReportAvailable: "Níl aon tuairisc ar fáil",
      noDataAvailable: "Níl aon sonraí ar fáil",
      resetView: "Athshocraigh an Radharc",
      fleetOverview: "Ábharthacht na Flot",
      functionalLocation: "Láthair Fheidhmeach",
    },
    words: {
      total: "Iomlán",
      this: "Seo",
      all: "Gach",
      watchList: "Liosta Féachana",
      schedule: "Sceideal",
      client: "Custaiméir",
      recepients: "Gonraithe",
      more: "Tuilleadh",
      devices: "Uirlisí",
      search: "Cuardaigh",
      reset: "Athshocraigh",
      save: "Sábháil",
      language: "Teanga",
      english: "Béarla",
      french: "Fraincis",
      back: "Ar Ais",
      clear: "Glan",
      to: "go",
      standard: "Caighdeánach",
      commuter: "Comaitéir",
      nonCommuter: "Neamhcomaitéir",
      edit: "Eagar",
      cancel: "Cealaigh",
      saveAs: "Sábháil Mar",
      alert: "Fógra",
      last: "Deireanach",
      preferences: "Roghanna",
    },
    messages: {
      success: {
        deviceDetailsSaved: "Sonraí Uirlisí Sábháilte go Rathúil!",
        good: "Maith",
      },
      warnings: {
        temperatureError: "Earráid Teocht",
        temperatureInvestigationWarning: "Háiseanna le rabhadh teochta a d'fhéadfadh a bheith ag teastáil taighde",
        missedMessages: "Teachtaireachtaí Teoranta",
        noCommunications: "Gan Cumarsáid",
      },
      errors: {},
      filter: {
        filterApplied: "Cuir Fíltrí i bhfeidhm go Rathúil",
        filterRemoved: "Bain Fíltrí go Rathúil",
        filterError: "Earráid agus an Fíltrí",
      },
    },
    measure: {
      kVA: "kVA",
      kW: "kW",
    },
    times: {
      days: {
        sunday: "Dé Domhnaigh",
        monday: "Dé Luain",
        tuesday: "Dé Máirt",
        wednesday: "Dé Céadaoin",
        thursday: "Déardaoin",
        friday: "Dé hAoine",
        saturday: "Dé Sathairn",
      },
      months: {
        january: "Eanáir",
        february: "Feabhra",
        march: "Márta",
        april: "Aibreán",
        may: "Bealtaine",
        june: "Meitheamh",
        july: "Iúil",
        august: "Lúnasa",
        september: "Meán Fómhair",
        november: "Samhain",
        december: "Nollaig",
        jan: "Ean",
        feb: "Feabh",
        mar: "Márta",
        apr: "Aib",
        my: "Beal",
        jun: "Meith",
        jul: "Iúil",
        aug: "Lún",
        sep: "MFómh",
        nov: "Samh",
        dec: "Noll",
      },
      time: {
        today: "Inniu",
        second: "Soicind",
        seconds: "Soicind",
        minute: "Nóiméad",
        minutes: "Nóiméad",
        hr: "Uair",
        hrs: "Uair",
        day: "Lá",
        days: "Lá",
        week: "Seachtain",
        weeks: "Seachtain",
        month: "Mí",
        months: "Mí",
        year: "Bliain",
        years: "Bliain",
        secondsAge: "Soicind ó shin",
        minutesAge: "Nóiméad ó shin",
        hoursAgo: "Uair an chloig ó shin",
        daysAgo: "Lá ó shin",
        weeksAgo: "Seachtain ó shin",
        monthsAgo: "Mí ó shin",
        yearsAgo: "Bliain ó shin",
        last24Hours: "Na 24 Uair an Chloig Seo Caidreamh",
        last7Days: "Na 7 Lá deireanacha Caidreamh",
        last28Days: "Na 28 Lá deireanacha Caidreamh",
        lastWeek: "An tSeachtain Deiridh",
        last4Weeks: "Na 4 Seachtain Deireanacha",
        last8Weeks: "Na 8 Seachtain Deireanacha",
        last3Months: "Na 3 Mí Deiridh",
        last6Months: "Na 6 Mí Deireanacha",
        last1Year: "An Bliain Deiridh",
        TwentyFourHours: "24 Uair an Chloig",
        SevenDays: "7 Lá",
        TwentyEightDays: "28 Lá",
      },
    },
  },
  views: {
    Alerts: {},
    Analytics: {
      mainTitle: "Anailís",
      pageTitle: "Torthaí",
      charts: {
        totalPower: {
          title: "Cumhacht Iomlán",
          xLabel: "Cumas (kVA)",
          yLabel: "Séanra",
          bottomLabelMaxCapacity: "Cumas Mór Iomlán",
          bottomLabelTotalCapacity: "Cumas Iomlán Úsáidte",
        },
        issues: {
          title: "Gnáthú",
          xLabel: "Gnáthú",
          yLabel: "Líon na gGadaithe",
          hAxis: {
            HasCapacityUnderLimit: {
              label: "Cumas Faoin Limistéar",
              tooltip: "Áiseanna le cumas níos lú ná 15%",
            },
            HasCapacityOverLimit: {
              label: "Cumas Os Cionn an Limistéir",
              tooltip: "Áiseanna le cumas níos mó ná 85%",
            },
            HasMissedMessages: {
              label: "Teachtaireachtaí Teoranta",
              tooltip: "Áiseanna le teachtaireachtaí teoranta",
            },
            HasImbalance: {
              label: "Neamhcothromaíocht Fáis",
              tooltip: "Áiseanna le meitibileacht uachtair > 90%",
            },
            HasCurrentOverLimit: {
              label: "Príomhacht Os Cionn Limistéir",
              tooltip: "Áiseanna le príomhacht os cionn limistéir",
            },
            HasLowBattery: {
              label: "Bata Íseal",
              tooltip: "Áiseanna le bata íseal",
            },
            HasNoPower: {
              label: "Gan Cumhacht",
              tooltip: "Áiseanna gan cumhacht",
            },
            HasTemperatureOutsideRange: {
              label: "Teocht lasmuigh den Raon",
              tooltip: "Áiseanna le teocht lasmuigh den raon",
            },
            HasTemperatureOverLimit: {
              label: "Teocht Os Cionn an Limistéir",
              tooltip: "Áiseanna le teocht os cionn limistéir",
            },
            HasTemperatureSenseError: {
              label: "Rabhadh Teochta",
              tooltip: "Áiseanna le rabhadh teochta",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "Áiseanna",
          columns: {
            id: "Aitheantas na hÁise",
            type: "Cineál Monatóra",
            t_name: "Ainm an tTransfórmálaí",
            t_size: "Méid an tTransfórmálaí",
            capacity: {
              text: "Cumas",
              tooltip:
                "% de chumas iomlán atá ar fáil i n-úsáid. (Meáchan Láracháin Iomlán * 230/1000) / Rátáil Cumhachta (%)",
            },
            power: {
              text: "Cumhacht Iomlán",
              tooltip: "Méideanna cumhachta is mó comhoiriúnachta de gach phéire iomaithe le linn na tréimhse.",
            },
            l_message: "An Teachtaireacht Dheireanach",
          },
        },
      },
    },
    Asset: {
      deviceDetails: {
        transformerName: {
          label: "Ainm an Trafómhair",
        },
        transformerNo: {
          label: "Uimhir an Trafómhair",
        },
        transformerSize: {
          label: "Méid an Trafómhair",
        },
        assetId: {
          label: "Aitheantas na hÁis",
        },
        deviceStatus: {
          label: "Stádas na Gléas",
        },
        deviceVoltage: {
          label: "Fuinneamh na Gléas",
        },
        installationDate: {
          label: "Dáta Suiteála",
        },
        connectedMPRNs: {
          label: "MPRNanna Ceangailte",
        },
        commuterArea: {
          label: "Ceantar Comála",
        },
      },
      latestMessage: {
        title: "An Teachtaireacht Is Déanaí",
        currentPH1: {
          label: "Príomhacht PH1",
          suffix: "A",
          helptext: "(Meá./Max.)",
        },
        currentPH2: {
          label: "Príomhacht PH2",
          suffix: "A",
          helptext: "(Meá./Max.)",
        },
        currentPH3: {
          label: "Príomhacht PH3",
          suffix: "A",
          helptext: "(Meá./Max.)",
        },
        temperature: {
          label: "Teocht",
          suffix: "°C",
          helptext: "(Meá./Max.)",
        },
      },
      calculatedReadings: {
        title: "Léamhanna Caighdeánaithe",
        totalPower: {
          label: "Cumhacht Iomlán",
          suffix: "kVA",
        },
        capacity: {
          label: "Cumas",
          suffix: "%",
        },
        imbalance: {
          label: "Neamhcothromaíocht",
          suffix: "%",
        },
        utilization: {
          label: "Úsáid",
          suffix: "%",
        },
      },
      tabs: {
        charts: {
          label: "Síntí",
        },
        messages: {
          label: "Teachtaireachtaí",
        },
        evAnalysis: {
          label: "Anailís EV",
        },
        hpAnalysis: {
          label: "Anailís HP",
        },
      },
      charts: {
        chartConfig1: {
          title: "Roghnaigh gléas le hcomparáid",
          temp: {
            label: "Teocht (°C)",
            xAxis: "Timestamp",
            yAxis: "Teocht (°C)",
          },
          diff: {
            label: "Teocht (°C)",
            xAxis: "Timestamp",
            yAxis: "Teocht",
          },
          imbalance: {
            label: "Neamhcothromaíocht agus Meáin-Mheáin na Príomhachtaí(A)",
            labelDailyStats: "Neamhcothromaíocht agus Príomhachtaí(A)",
            xAxis: "Timestamp",
            yAxis: "Lán-Phléasc (A)",
            yBarAxis: "Neamhcothromaíocht (%)",
          },
          totalPower: {
            label: "Cumhacht Iomlán agus Meáin-Mheáin na Príomhachtaí(A)",
            labelDailyStats: "Cumhacht Iomlán agus Príomhachtaí(A)",
            xAxis: "Timestamp",
            yAxis: "Lán-Phléasc (A)",
            yBarAxis: "Cumhacht Iomlán (kVA)",
          },
          imbalanceMax: {
            label: "Neamhcothromaíocht agus an Príomhacht Mheasctha(A)",
            xAxis: "Timestamp",
            yAxis: "Lán-Phléasc",
            yBarAxis: "Neamhcothromaíocht",
          },
          totalPowerMax: {
            label: "Cumhacht Iomlán agus an Príomhacht Mheasctha(A)",
            xAxis: "Timestamp",
            yAxis: "Lán-Phléasc (A)",
            yBarAxis: "Cumhacht Iomlán (kVA)",
          },
        },
      },
      tables: {
        messages: {
          columns: {
            seqNo: {
              text: "Uimhir Ordaithe",
            },
            messageTime: {
              text: "Am an Teachtaireachta",
            },
            missedMessage: {
              text: "Teachtaireacht Caillte",
            },
            lqi: {
              text: "LQI",
            },
            medCurrentPH1: {
              text: "Príomhacht Meáin PH1",
              suffix: "A",
            },
            maxCurrentPH1: {
              text: "Príomhacht Uasmhéadúil PH1",
              suffix: "A",
            },
            medCurrentPH2: {
              text: "Príomhacht Meáin PH2",
              suffix: "A",
            },
            maxCurrentPH2: {
              text: "Príomhacht Uasmhéadúil PH2",
              suffix: "A",
            },
            medCurrentPH3: {
              text: "Príomhacht Meáin PH3",
              suffix: "A",
            },
            maxCurrentPH3: {
              text: "Príomhacht Uasmhéadúil PH3",
              suffix: "A",
            },
            maxTemp: {
              text: "Teocht Uasmhéadaithe",
              suffix: "°C",
            },
            medTemp: {
              text: "Meánteocht",
              suffix: "°C",
            },
            capacity: {
              text: "Cumas",
              suffix: "%",
              tooltip:
                "% den chumas iomlán atá ar fáil in úsáid. (Meán-Phríomhacht Iomlán * 230/1000) / Íomháphraghas (%)",
            },
            imbalance: {
              text: "Neamhcothromaíocht",
              suffix: "%",
              tooltip:
                "Neamhcothromaíocht idir phríomhachtaí. Meáchan an Mhéadach agus an Meáin-Chorr / Meáin-Chorr (%) *do 3 phríomhachta amháin",
            },
          },
        },
      },
    },
    Assets: {
      pageTitle: "Ábharthacht na bPraitheoirí",
      deviceCoverage: "Seiceáil Cúram na bPraitheoirí",
      charts: {
        capacity: {
          title: "Cumas",
          tooltip:
            "Mheasaíonn anailís cumais an méid cumais atá in úsáid in aghaidh gach praitheora agus straitisítear é de réir an iomarcaithe, an gnáth nó na hoibreacha faoi chaighdeán.",
          header: {
            capacity: "Cumas",
            numberOfDevices: "Líon na bPraitheoirí",
          },
          data: {
            underperforming: {
              text: "Gníomhacht i Bhfadán",
              message: "Praitheoirí faoin teorainn reatha - Níos lú ná 15% Cumas",
            },
            normal: {
              text: "Gnáth",
              message: "Praitheoirí leis an gcurraim reatha - Idir 15% agus 85% Cumas",
            },
            overutilised: {
              text: "Iomarcaithe",
              message: "Praitheoirí os cionn na teorainne reatha - Níos mó ná 85% Cumas",
            },
          },
        },
        imbalance: {
          title: "Neamhlíneacht",
          tooltip:
            "Mheasaíonn anailís ar an neamhlíneacht an méid neamhlíneachta atá ann ar an 3 ghairm ag gach praitheoir agus straitisítear é de réir an neamhlíneachta nó an gnáth.",
          header: {
            imbalanceStatus: "Stádas Neamhlíneachta",
            numberOfDevices: "Líon na bPraitheoirí",
          },
          data: {
            normal: {
              label: "Gnáth",
              message: "Praitheoirí gan neamhlíneacht.",
            },
            imbalance: {
              label: "Neamhlíneacht",
              message: "Praitheoirí le neamhlíneacht.",
            },
          },
        },
        powerChange: {
          title: "Athrú Cumais",
          tooltip:
            "Mheasaíonn athrú cumais an méid athruithe cumais atá ann in aghaidh gach praitheora agus straitisítear é de réir neamhghnáth nó gnáth.",
          header: {
            powerChangeStatus: "Stádas Athruithe Cumais",
            numberOfDevices: "Líon na bPraitheoirí",
          },
          data: {
            normal: {
              label: "Gnáth",
              message: "Praitheoirí gan athrú cumais neamhghnáth.",
            },
            abnormal: {
              label: "Neamhghnáth",
              message: "Praitheoirí le hathrú cumais neamhghnáth.",
            },
          },
        },
        batteryStatus: {
          title: "Stádas na mBatairí",
          tooltip: "Taispeánann stádas na mbeochan ar fad agus straitisítear é de réir ard, íseal nó anaithnid.",
          header: {
            batteryStatus: "Stádas na mBatairí",
            numberOfDevices: "Líon na bPraitheoirí",
          },
          data: {
            highBattery: {
              label: "Ard Batairí",
              message: "Praitheoirí le batairí ard.",
            },
            lowBattery: {
              label: "Íseal Batairí",
              message: "Praitheoirí le batairí íseal.",
            },
            unknownBattery: {
              label: "Anaithnid Batairí",
              message: "Praitheoirí le batairí anaithnid.",
            },
          },
        },
        devicesCommunication: {
          title: "Cumarsáid na bPraitheoirí",
          tooltip:
            "Taispeánann an cumarsáid ar fad a bhaineann leis na praitheoirí agus straitisítear é de réir cumarsáide, gan cumarsáid nó teachtaireachtaí a chailleadh.",
          header: {
            connectivity: "Ceangal",
            numberOfDevices: "Líon na bPraitheoirí",
          },
          data: {
            communicated: {
              label: "Cumarsáid Déanta",
              message: "Praitheoirí gan teachtaireachtaí caillte",
            },
            noCommunications: {
              label: "Gan Cumarsáid",
              message: "Praitheoirí nach bhfuil cumarsáid acu le 24 uair an chloig anuas",
            },
            missedMessages: {
              label: "Teachtaireachtaí Caillte",
              message: "Praitheoirí le teachtaireachtaí caillte",
            },
          },
        },
        devicesStatus: {
          title: "Stádas na bPraitheoirí",
          tooltip:
            "Taispeánann an stádas/nithe faoi na praitheoirí ar fad agus straitisítear é de réir gan fhadhb, fadhb neamhlíneachta, teas taobh amuigh den raon, curraim os cionn teorainne, fadhb cumarsáide, fadhb cumhachta, fadhb le cinn teasa, teas os cionn teorainne nó fadhb batairí.",
          header: {
            deviceStatus: "Stádas na bPraitheoirí",
            numberOfDevices: "Líon na bPraitheoirí",
          },
          data: {
            noIssue: {
              label: "Gan Fhadhb",
              message: "Praitheoirí gan fadhbanna.",
            },
            phaseImbalance: {
              label: "Neamhlíneacht Ghairm",
              message: "Praitheoirí leis an neamhlíneacht mó > 90%.",
            },
            temperatureAlert: {
              label: "Rabhadh Teas",
              message: "Praitheoirí le rabhadh teas a d'fhéadfadh gur gá iniúchadh a dhéanamh orthu",
            },
            currentOverlimit: {
              label: "Curraim Os Cionn Teorainne",
              message: "Praitheoirí le curraim os cionn teorainne.",
            },
            communicationProblem: {
              label: "Fadhb Cumarsáide",
              message: "Praitheoirí le fadhb cumarsáide.",
            },
            noPower: {
              label: "Gan Cumhacht",
              message: "Praitheoirí le fadhb cumhachta.",
            },
            lowBattery: {
              label: "Íseal Batairí",
              message: "Praitheoirí le fadhbanna batairí.",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "",
          filters: {
            primary: {},
            secondary: {
              list_checkbox: {
                label: "Cineál na gPraitheoirí",
              },
              flags: {
                temperatureOverlimit: {
                  label: "Teocht Os Cionn Teorainne",
                },
                currentOverlimit: {
                  label: "Curraim Os Cionn Teorainne",
                },
              },
              range: {
                transformerSize: {
                  label: "Méid an tPréamhathraithe",
                },
                maxCurrentPH1: {
                  label: "Curraim Mórdhíola PH1",
                },
                maxCurrentPH2: {
                  label: "Curraim Mórdhíola PH2",
                },
                maxCurrentPH3: {
                  label: "Curraim Mórdhíola PH3",
                },
                maxTemperature: {
                  label: "Teocht Mórdhíola",
                },
              },
            },
          },
          columns: {
            deviceId: {
              text: "Aitheantas na gCríche",
            },
            monitorType: {
              text: "Cineál Monatóireachta",
            },
            deviceName: {
              text: "Ainm",
            },
            powerRating: {
              text: "Méid an tPréamhathraithe",
            },
            totalPower: {
              text: "Cumhacht Iomlán",
              tooltip: "Measaimid an cumhacht mhórdhíola comhdhéanta i gach chéim measctha le linn an tréimhse.",
            },
            maxCapacity: {
              text: "Cumas Mórdhíola (%)",
              tooltip:
                "% den chumas iomlán atá ar fáil i n-úsáid. (Curraim Mórdhíola Iomlán * 230/1000) / MeáchanCumhachta (%)",
            },
            maxImbalance: {
              text: "Neamhlíneacht Mórdhíola (%)",
              tooltip:
                "Neamhlíneacht reatha idir na ghnáthchéimeanna. An difear is mó idir phas agus Meáchan Neamhspleách / Meáchan Neamhspleách (%) * do 3 chéim amháin",
            },
            current0Max: {
              text: "Curraim Mórdhíola PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Teocht Mórdhíola",
            },
            isCommuterArea: {
              text: "Ceantar Comaitéaraí",
            },
            isWatchlisted: {
              text: "",
            },
            moreActions: {
              text: "",
            },
          },
        },
      },
      texts: {
        batteryTooltip: {
          message: "Batairí",
        },
        state: {
          normal: "Gnáth",
          overUtilised: "Iomarcaithe",
          underperforming: "Gníomhacht i Bhfadán",
          unknown: "Anaithnid",
        },
        summary: {
          title: "Achoimre",
          activeDevices: "Praitheoirí Gníomhacha",
          totalDevices: "Líon na bPraitheoirí",
          inactiveDevices: "Praitheoirí Neamhghníomhacha",
        },
        deviceDetails: {
          title: "Sonraí an Phraitheora",
          deviceName: "Ainm an Phraitheora",
          deviceId: "Aitheantas na gCríche",
          monitorType: "Cineál Monatóireachta",
          transformerSize: "Méid an tPréamhathraithe",
          maxCurrentPH1: "Curraim Mórdhíola PH1",
          maxCurrentPH2: "Curraim Mórdhíola PH2",
          maxCurrentPH3: "Curraim Mórdhíola PH3",
          maxTemperature: "Teocht Mórdhíola",
          powerRating: "Méid an tPréamhathraithe",
          totalPower: "Cumhacht Iomlán",
          maxCapacity: "Cumas Mórdhíola",
          maxImbalance: "Neamhlíneacht Mórdhíola",
          current0Max: "Curraim Mórdhíola PH1-PH2-PH3",
          batteryStatus: "Stádas na mBatairí",
          noBatteryData: "Sonraí anaithnid",
          communicationStatus: "Stádas Cumarsáide",
          powerChangeStatus: "Stádas Athruithe Cumais",
          deviceStatus: "Stádas an Phraitheora",
          noIssues: "Gan fhadhbanna",
          flaggedIssues: "Fhadhbanna a bhfuil marcanna orthu",
          temperatureOverlimit: "Teocht os cionn teorainne",
          currentOverlimit: "Curraim os cionn teorainne",
        },
        filterModal: {
          title: "Scagaire Sonraí",
          closeButton: "Dún",
          resetButton: "Athshocraigh",
          applyButton: "Seol",
        },
      },
      modal: {
        flaggedIssue: {
          title: "Fhadhbanna a bhfuil Marcanna Orthu",
          closeButton: "Dún",
        },
      },
    },
    AssetSnapshotView: {},
    CoverageChecker: {},
    Device: {},
    DeviceCoverage: {},
    DeviceHome: {},
    Error: {},
    EVModelling: {
      charts: {
        maxEVSupported: {
          title: "Méid Uasmhéadaithe EVanna",
          labels: {
            maxEVs: "Méid Uasmhéadaithe EVanna",
            numberOfDevices: "Líon na Gléasanna",
          },
        },
        maxHPSupported: {
          title: "Méid Uasmhéadaithe HPanna",
          labels: {
            maxHP: "Méid Uasmhéadaithe HPanna",
            numberOfDevices: "Líon na Gléasanna",
          },
        },
        firstYearOverCapacity: {
          title: "Bliain an Chéad Chaidreamh",
          labels: {
            xLabel: "Bliain an Chéad Chaidreamh",
            yLabel: "Uimhir na Gléasanna",
          },
        },
      },
      tables: {
        deviceEVMTable: {
          title: "",
          columns: {
            deviceId: {
              text: "Aitheantas na Gléas",
            },
            maxEVs: {
              text: "Méid Uasmhéadaithe EVanna",
            },
            maxEVHour: {
              text: "Uair Uasmhéadaithe EVanna",
            },
            firstYearOverCapacity: {
              text: "An Chéad Bhliain Os Cionn an Chumas Comhcheangailte",
            },
            maxLoadDay: {
              text: "Lá an Lán-Phléasc",
            },
            minHeadroom: {
              text: "Barrscála Íosta",
            },
            maxLoad: {
              text: "Lán-Phléasc Mheasctha",
            },
            maxLoadHour: {
              text: "Uair an Lán-Phléasc",
            },
          },
        },
      },
    },
    Home: {},
    HPModelling: {},
    Journey: {},
    Journeys: {},
    Location: {},
    LocationList: {},
    PoiReport: {},
    PowerdataAlerts: {
      title: "",
      tabs: {
        activeAlerts: {
          label: "Eolas Gníomhach",
        },
        manageAlerts: {
          label: "Bainistiú Rabhaidh",
        },
      },
      alert: {
        alarm: {
          label: "Aláram",
        },
        maxCurrentPH1: {
          label: "Uasmhéid Comhchuibhe PH1",
        },
        medCurrentPH1: {
          label: "Meánluas Comhchuibhe PH1",
        },
        maxCurrentPH2: {
          label: "Uasmhéid Comhchuibhe PH2",
        },
        medCurrentPH2: {
          label: "Meánluas Comhchuibhe PH2",
        },
        maxCurrentPH3: {
          label: "Uasmhéid Comhchuibhe PH3",
        },
        medCurrentPH3: {
          label: "Meánluas Comhchuibhe PH3",
        },
        maxTemperature: {
          label: "Teocht Uasmhéid",
        },
        medTemperature: {
          label: "Meánluas Teocht",
        },
        imbalance: {
          label: "Disceartú",
        },
        totalPower: {
          label: "Cumhacht Iomlán",
        },
      },
      tables: {
        alerts: {
          columns: {
            alertId: {
              text: "Aitheantas Rabhaidh",
            },
            deviceId: {
              text: "Aitheantas na Gléas",
            },
            deviceType: {
              text: "Cineál na Gléas",
            },
            triggerField: {
              text: "Réimse Téagartha",
            },
            triggerValue: {
              text: "Luach Téagartha",
            },
            triggerOperator: {
              text: "Feidhmeannach Téagartha",
            },
            moreActions: {
              text: "",
              labels: ["Bainistiú Ríomhphoistithe", "Athraigh Sonraí", "Scrios"],
            },
          },
        },
        activeAlerts: {
          columns: {
            alertId: {
              text: "Aitheantas Rabhaidh",
            },
            deviceId: {
              text: "Aitheantas na Gléas",
            },
            fullName: {
              text: "Ainm",
            },
            deviceType: {
              text: "Cineál na Gléas",
            },
            triggerField: {
              text: "Réimse Téagartha",
            },
            triggerValue: {
              text: "Luach Téagartha",
            },
            actualValue: {
              text: "Luach Fíorúil",
            },
            triggerDate: {
              text: "Dáta Téagartha",
            },
          },
        },
      },
    },
    PowerdataReports: {
      header: {},
    },
    PowerdataReportView: {},
    Profile: {
      userInformation: {
        title: "Eolas Úsáideora",
      },
      preferences: {
        language: "Sainroghanna Teanga",
        theme: "Sainroghanna Téama",
      },
      managePreferences: {
        title: "Bainistiú Roghanna",
        defaultTab: "Tábla Réamhshocraithe",
        manageSections: "Bainistiú Rannóga",
        arrangeSections: "Socrú Rannóga",
      },
    },
    Reports: {},
    Snapshot: {},
  },
  components: {
    AlertsTemplate: {
      labels: {
        deviceType: "Cineál Thiomána",
        triggerField: "Réimse Tiomána",
        triggerValue: "Luach Tiomána",
        device: "Gléas",
        triggerOperator: "Feidhmí Tiomána",
      },
    },
    AreaChartVT: {},
    AssetSnapshot: {},
    ColumnChartVT: {},
    ComboChart: {},
    ComboChartVT: {},
    DataTableVT: {},
    DaysSelector: {},
    DialogVT: {
      contactVT: "Déan teagmháil le VT, le do thoil...",
      desc: "Tá rochtain teoranta agat ar na gnéithe atá ar fáil san iarratas. Déan teagmháil le VT chun tuilleadh eolais a fháil faoi na gnéithe a chuirtear ar fáil.",
    },
    DiffAreaChart: {},
    DiffChart: {},
    DistributionBarVT: {},
    EditAssetDetails: {},
    EditLocationDetails: {},
    Error: {},
    EVModelDetails: {},
    EVModelEditDetails: {
      labels: {
        selectModel: "Roghnaigh Moedel",
        selectDayType: "Roghnaigh Cineál an Lae",
        useCommuterStatus: "Úsáid Stádas Taistil",
        mostRecentWeekday: "An Lae Seachtrach is Déanaí",
        mostRecentWeekdayTooltip: "* A bhfuil 24 uair an chloig de shonraí teachtaireachta ann",
        maxAnnualLoadDay: "An Lae Lánleithid Bliantúil Mórmhéide",
        evModelDetails: "Sonraí an Mhóidil VE",
        chooseModelName: "Roghnaigh Ainm an Mhóidil",
        modelName: "*Ainm an Mhóidil",
        indicatesRequiredField: "*Taispeánann Réimse Riachtanach",
        chargeRateWeekday: "Ráta Casadh (Laethanta na Seachtaine)",
        chargeRateWeekend: "Ráta Casadh (Deireadh Seachtaine)",
        chargeDurationWeekday: "Tréimhse Casadh, Laethanta na Seachtaine (Uair)",
        chargeDurationWeekend: "Tréimhse Casadh, Deireadh Seachtaine (Uair)",
        ratioOfHigh1: "Caitheamh Teocht Uachtarach (7Kw) le haghaidh Ceanglóirí Cumhachta Íseal (3Kw) (%) [Pro VE = ",
        ratioOfHigh2: " kVa]",
        ratioOfBEV: "Caitheamh Folaíochta VE le Cuspóirí PHEV (%)",
        confidenceLevel: "Leibhéal Muiníne (%) (Rannán Binomial)",
        percentageOfPeopleWhoPurchase: "Céatadán daoine a cheannach gluaisteán nua in aghaidh na bliana (%)",
        modifyProbalities: "Athraigh na Dearachtaí",
        changeProbabilityDistribution: "Athraigh Sraithbhagairt na Dearachtaí",
      },
      charts: {
        evForecast: {
          title: "Réamhaisnéis faoin mhalairt meáchan na n-iarratas VE in aghaidh na bliana (go dtí 2030)",
          label: "Réamhaisnéis Mhargaidh na nIarratas VE",
          xAxis: "Bliain",
          yAxis: "% Gluaisteán Leictreach",
          vAxes: {
            title: "% Margaidh na nIarratas VE",
          },
          hAxis: {
            title: "Bliain",
          },
        },
        cumulProbChart: {
          title: "Coinníoll go mbeidh gluaisteán VE ag tarraingt lóistín in aghaidh na huaire",
          label: "Anailís Comhoiriúnachta Cumais",
          xAxis: "Uair na hAoine",
          yAxis: "Deiseanna Casadh",
          vAxes: {
            title: "Deiseanna Casadh",
          },
          chartLabels: {
            0: "Meánréimse",
            1: "Deiseanna Casadh (%)",
          },
        },
        powerLoadDataOnly: {
          title: {
            1: "Anailís Lóistín / Áirdleithid an tSreabh [ ",
            2: " ]",
          },
          label: "Áirdleithid an tSreabh",
          yLabel: "Uair na hAoine",
          xLabel: "Lucht (kVa)",
          vAxes: {
            0: { title: "Lucht (kVa)" },
            1: { title: "Áirdleithid (kVa)" },
          },
          chartLabels: {
            0: { title: "Uair na hAoine" },
            1: { title: "Lucht Iomlán" },
            2: { title: "Áirdleithid" },
            3: { title: "Lucht Uasmhéide" },
          },
        },
        evModelChart: {
          title: "Líon is mó gluaisteán VE breise ar an dtraeinsteoróip seo (Anailís Sraithbhagairt Binomial)",
          label: "Anailís an Líon Gluaisteán VE",
          xAxis: "Uair na hAoine",
          yAxis: "# Ceanglóirí VE",
          vAxes: {
            0: { title: "# Ceanglóirí VE" },
            1: { title: "MAX_EVS = " },
          },
          chartLabels: {
            0: { title: "Meánréimse" },
            1: { title: "Uasmhéid na gCeanglóirí" },
            2: { title: "Uasmhéid VEanna" },
          },
        },
        totalNewEVCharge: {
          title: "Réamhaisnéis na nIarratas VE Nua in aghaidh na Bliana ar an dtraeinsteoróip seo",
          label: "Méid na nIarratas VE nua atá Caite in Aghaidh na Bliana",
          xAxis: "Bliain",
          yAxis: "# Iomlán na nIarratas VE Nua",
          vAxes: {
            title: "# Iomlán na nIarratas VE Nua",
          },
          hAxis: {
            title: "Bliain",
          },
          chartLabels: {
            0: { title: "Bliain" },
            1: { title: "Líon na nIarratas VE" },
            2: { title: "Chéad bhliain os cionn an chumas" },
          },
        },
      },
    },
    FleetReport: {},
    HomeContent: {},
    HPModelEditDetails: {
      filters: {
        modelName: {
          label: "Roghnaigh Moedel",
        },
        dayType: {
          label: "Roghnaigh Cineál an Lae",
          tooltip: "Roghnaigh an lae is déanaí, nó an lae is measa le lóistín sa bhliain",
          mostRecentWeekday: "An Lae Seachtrach is Déanaí",
          maxAnnualLoadDay: "An Lae Lánleithid Bliantúil Mórmhéide",
          mostRecentWeekdayTooltip: "* A bhfuil 24 uair an chloig de shonraí teachtaireachta ann",
        },
        extremeScenerio: {
          label: "Cás Scéalaíochta Éadroime ('1 amach de 20')",
          tooltip: "Móideanna don 'barr sealaíochta geimhridh' neamhghnách (m.sh. -5 céim)",
        },
      },
      title: "Sonraí an Mhóidil TFA",
      subTitle: "Ainm an Mhóidil",
      HPModelEdit: {
        labels: {
          chooseModelName: "Roghnaigh Ainm an Mhóidil",
          ratioOfNewBuildExistingHomes: {
            title: "Caitheamh TFA Cónaithe Nua/Maoin TFA Iontacha (%)",
            labelA: "Cónaithe Nua",
            labelB: "Iontacha",
          },
          ratioOfDetachedvsSemi: {
            title: "Caitheamh TFA Cónaithe Dúbailte/iompairaí ar 'Dacha' (%)",
            labelA: "Dúbailte",
            labelB: "Iompairaí",
          },
          ratioOfHybridvsAir: {
            title: "Caitheamh TFA Cónaithe Híbhríde/ASF i gcomparáid le HP Aer (%)",
            labelA: "Híbhríde",
            labelB: "ASF",
          },
          ratioOfHighTemp: {
            title: "Caitheamh TFA Aer Ardteocht (HT) i gcomparáid le TFA Aer Teocht Íseal (LT) (%)",
            labelA: "HT",
            labelB: "LT",
          },
          percentageOfPeopleWhoInstall: {
            title: "Céatadán daoine a shuíonn TFA i dtimpeallacht in aghaidh na bliana (%)",
            labelA: "Réimse",
          },
        },
      },
      charts: {
        loadProfiles: {
          title: "Próifílanna Lóistín TFA Típiciúla (kW) de réir cineál teach agus cineál TFA",
          label: "Próifílanna Lóistín TFA",
          xAxis: "Uair na hAoine",
          yAxis: "Lucht TFA (kW)",
          vAxes: {
            0: { title: "Lucht TFA (kW)" },
          },
        },
        HPLoadChart: {
          title: "Próifíl Lóistín Meastaithe (kVA) TFA de réir móidil",
          label: "Anailís Lóistín TFA",
          xAxis: "Uair na hAoine",
          yAxis: "Lucht TFA (kVA)",
          vAxes: {
            0: { title: "Lucht TFA (kVA)" },
          },
          labelA: "Meánréimse",
          labelB: "Lucht TFA (KVa)",
        },
        powerModel: {
          title: {
            0: "Anailís Lucht / Mórmhéid an Trasformadóra [",
            1: " ]",
          },
          label: "Lucht an Trasformadóra",
          xAxis: "Uair na hAoine",
          yAxis: "Lucht (kVa)",
          data: {
            0: "Meánréimse",
            1: "Lucht (KVa)",
          },
          vAxes: {
            0: { title: "Lucht (kVa)" },
            1: { title: "Áirdleithid (kVa)" },
          },
          labelA: "Uair na hAoine",
          labelB: "Lucht Iomlán",
          labelC: "Áirdleithid",
        },
        HPModel: {
          title: "Ceanglóirí TFA Breise Mórmhéide ar an Trasformadóir seo",
          label: "Anailís Airde TFA",
          xAxis: "Uair na hAoine",
          yAxis: "# TFA Tí",
          vAxes: {
            0: { title: "# TFA Tí" },
            1: { title: "MAX_HPS = " },
          },
          labelA: "Meánréimse",
          labelB: "Uasmhéid na TFAí",
        },
        HPCalculatedSales: {
          title: "Réamhaisnéis TFA Nua in aghaidh na Bliana ar an Trasformadóir seo",
          label: "Méid na TFAí Nua Atá Socraithe in Aghaidh na Bliana",
          xAxis: "Bliain",
          yAxis: "# Iomlán na TFAí Nua",
          vAxes: {
            0: { title: "# Iomlán na TFAí Nua" },
          },
          hAxis: {
            title: "Bliain",
          },
          labelA: "Bliain",
          labelB: "Líon na TFAí",
        },
      },
    },
    InputSelectVT: {},
    KPIReport: {},
    LineChart: {},
    LineChartVT: {},
    LoaderVT: {},
    MapInfoWindow: {},
    MapInfoWindowPowerdataTemplate: {},
    MapInfoWindowTemplate: {},
    MapMarkerVT: {},
    MapsVT: {},
    MapTooltipVT: {},
    MinMaxChart: {},
    NavBar: {},
    OverviewCardsVT: {},
    PageHeader: {},
    POISnapshot: {},
    PowerDataMainReport: {
      title: "Seo an tuarascáil inniu ó VT Electron",
      tables: {
        fleetStatus: {
          title: "Stádas na bhFothrach",
          columns: {
            issue: {
              text: "Gné",
            },
            numberOfAssets: {
              text: "Líon na gGníomhaireachtaí",
            },
            percentageDevices: {
              text: "%",
            },
          },
        },
        devices: {
          columns: {
            name: {
              text: "Ainm",
            },
            transformerSize: {
              text: "Méid an Trasformadóra",
            },
            maxCapacity: {
              text: "Móramhéid",
            },
            maxCurrent: {
              text: "Móramhéid Comhoiriúnachta PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Teocht Uasmhéid",
            },
            graph: {
              text: "",
            },
          },
        },
      },
    },
    PrimaryFiltersVT: {},
    RadialChartVT: {},
    ReportManagement: {},
    SecondaryFiltersVT: {},
    SelectVT: {},
    SnackBarVT: {},
    TooltipVT: {},
  },
};
